// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__mFSpG","title":"InfoRow_title__WJWc6"};